import { AbstractControl } from '@angular/forms';

export default function phoneOrEmail(control: AbstractControl) {
  if (!control || !control.value) {
    return null;
  }
  if (control.value) {
    const isValidPhone = (val: string) => {
      return val.replace(/\D/gi, '').length === 10;
    };

    const isValidEmail = (val: string) => {
      return val.indexOf('@') > -1 && val.indexOf('.') > -1;
    };

    if (isValidEmail(control.value) || isValidPhone(control.value)) {
      return null;
    }
    return {
      phoneOrEmail: true,
    };
  }
}
